import 'Resources/Css/site.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MapContainer from 'Components/Map/Containers/MapContainer';
import configureStore from 'Components/Map/Store';
import { SubscriptionTypes } from "WebSocket/CacheManager/SubscriptionTypes";
import CacheManagerDialogContainer from 'Common/Dialog/CacheManagerDialog/CacheManagerDialogContainer';
import ErrorBoundary from 'Common/Errors/ErrorBoundary';

const store = configureStore();

/**
* Provides the entry point to render compeonents in the given html element
* @return { void } returns null to indicate that it does not addtionaly rendering
*/
function renderApp() {

    let subscriptionTypes = [
        SubscriptionTypes.DetectorConfig,
        SubscriptionTypes.DetectorMap,
        SubscriptionTypes.Node,
        SubscriptionTypes.LinkData,
        SubscriptionTypes.LinkPollData,
        SubscriptionTypes.LinkGeometry,
        SubscriptionTypes.Camera,
        SubscriptionTypes.Dms
    ];

    // This code starts up the React app when it runs in a browser. It sets up the routing
    // configuration and injects the app into a DOM element.

    ReactDOM.render(
        <ErrorBoundary>
            <Provider store={store}>
                <CacheManagerDialogContainer store={store} subscriptionTypes={subscriptionTypes}>
                    <MapContainer />
                </CacheManagerDialogContainer>
            </Provider>
        </ErrorBoundary>,
        document.getElementById('react-app')
    );
}

renderApp();

// Allow Hot Module Replacement
if (module.hot) {
    module.hot.accept([
        "WebSocket/CacheManager/SubscriptionTypes",
        'Common/Dialog/CacheManagerDialog/CacheManagerDialogContainer',
        'Components/Map/Containers/MapContainer',
        'Components/Map/Store'
    ], renderApp);
}
